import React, { useState, useEffect } from "react";
import BodyWrapper from "../utils/BodyWrapper";
import Carousel from "../components/Carousel";
import CardComponent from "../components/CardComponent";
import EmptyCardComponent from "../components/EmptyCardComponent";
import { Link } from "react-router-dom";
import { API } from "../App";

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [posts, setPosts] = useState([]);
  const [mainPosts, setMainPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getHomeData();
  }, []);
  useEffect(() => {
    fetchPosts();
  }, [categories]);
  const getHomeData = async () => {
    const homeResponse = await fetch(`${API}/public/home`)
      .then((res) => res.json())
      .catch((err) => console.log(err));
    if (homeResponse) {
      setCategories(homeResponse.categories);
      setMainPosts(homeResponse.main);
    }
  };
  const getPosts = async (catId) => {
    const postsResponse = await fetch(
      `${API}/public/home/category-content/${catId}?limit=3`
    )
      .then((res) => (res.status === 200 ? res.json() : res.status))
      .catch((err) => console.log(err));
    if (postsResponse.publications) {
      return postsResponse.publications;
    } else {
      return [];
    }
  };
  const fetchPosts = async () => {
    const categorias = categories.map((cat) => {
      return new Promise(async (resolve, reject) => {
        try {
          resolve({
            title: cat.title,
            id: cat.id,
            [cat.title.toLowerCase()]: await getPosts(
              cat.id,
              cat.title.toLowerCase()
            ),
          });
        } catch (err) {
          console.log(err.message);
          reject(err.message);
        }
      });
    });
    Promise.all(categorias).then((result) => {
      setPosts(result);
      setTimeout(() => setLoading(false), 1000);
    });
  };
  return (
    <>
      <BodyWrapper>
        <div className="home__featureNav">
          {mainPosts && mainPosts.length > 0 && <Carousel list={mainPosts} />}
        </div>
        {loading ? (
          <h1 style={{ color: "white" }}>Cargando contenido...</h1>
        ) : (
          posts?.map((cat, i) => (
            <div key={`homeCat-${i}`} className="home__category">
              <div className="home__categoryUp">
                <div className="home__categoryUpHeader">
                  <h2 className="home__categoryName">{cat.title}</h2>
                  <Link
                    className="home__categoryViewMoreLink"
                    to={`/categorias/${cat.title
                      ?.split(" ")
                      .join("-")
                      .toLowerCase()}/${cat.id}`}
                  >
                    <span className="home__categoryViewMore">
                      <p className="home__categoryViewMoreText">Leer más</p>
                      <span className="home__categoryViewMoreArrows">
                        {">>"}
                      </span>
                    </span>
                  </Link>
                </div>

                <div className="home__categoryShadow">
                  <div className="home__categoryUpShadow"></div>
                  <div className="home__categoryUpStrongShadow"></div>
                </div>
              </div>
              <div className="home__categoryDown">
                <div className="home__categoryPosts">
                  {cat.title &&
                  cat[cat.title.toLowerCase()] &&
                  cat[cat.title.toLowerCase()][0] ? (
                    <CardComponent
                      key={`cardPost-0`}
                      post={cat[cat.title.toLowerCase()][0]}
                      category={cat.title}
                    />
                  ) : (
                    <EmptyCardComponent key={`cardPost-0`} />
                  )}
                  {cat.title &&
                  cat[cat.title.toLowerCase()] &&
                  cat[cat.title.toLowerCase()][1] ? (
                    <CardComponent
                      key={`cardPost-1`}
                      post={cat[cat.title.toLowerCase()][1]}
                      category={cat.title}
                    />
                  ) : (
                    <EmptyCardComponent key={`cardPost-1`} />
                  )}
                  {cat.title &&
                  cat[cat.title.toLowerCase()] &&
                  cat[cat.title.toLowerCase()][2] ? (
                    <CardComponent
                      key={`cardPost-2`}
                      post={cat[cat.title.toLowerCase()][2]}
                      category={cat.title}
                    />
                  ) : (
                    <EmptyCardComponent key={`cardPost-2`} />
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </BodyWrapper>
    </>
  );
}
